export function getIsOpenInformation(): boolean {
    const NOW = new Date();

    // sunday
    if (NOW.getDay() === 0) {
        return false;
    }

    // before 9am
    if (NOW.getTime() < new Date().setHours(9, 0, 0, 0)) {
        return false;
    }

    // after 6pm
    if (NOW.getTime() >= new Date().setHours(18, 0, 0, 0)) {
        return false;
    }

    // after 1pm and saturday
    if (NOW.getDay() === 6 && NOW.getTime() >= new Date().setHours(13, 0, 0, 0)) {
        return false;
    }

    return true;
}
